import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader } from "antd";
import { SafetyCertificateOutlined, FileProtectOutlined, ExperimentOutlined } from "@ant-design/icons";
import { ButtonItem, SegmentedItem, TourItem } from "../../../../Components/Items";
import CertificadosEmitidos from "./CertificadosEmitidos";
import PlantillasCertificado from "./PlantillasCertificado";
import EquiposPatron from "./EquiposPatron";
import "../cmms.css";

// Certificados de verificacion (F-SE-14): los emitidos, las plantillas y los equipos patron.
// Los certificados se emiten y se descargan desde la Orden de Servicio.

const LLAVE_VISTA = "cmmsCertificadosVista";
const vistaGuardada = () => {
    try {
        return localStorage.getItem(LLAVE_VISTA) || "emitidos";
    } catch (e) {
        return "emitidos";
    }
};

class Certificados extends Component {
    state = { vista: vistaGuardada(), openTour: false };

    cambiarVista = (vista) => {
        try {
            localStorage.setItem(LLAVE_VISTA, vista);
        } catch (e) {
            // sin almacenamiento local: solo no se recuerda
        }
        this.setState({ vista });
    };

    render() {
        const { vista } = this.state;
        return (
            <div className="cmms-pagina">
                <PageHeader
                    title="Certificados"
                    subTitle="Certificados de verificación"
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
                    extra={
                        <>
                            <SegmentedItem
                                options={[
                                    { label: <span><SafetyCertificateOutlined /> Emitidos</span>, value: "emitidos" },
                                    { label: <span><FileProtectOutlined /> Plantillas</span>, value: "plantillas" },
                                    { label: <span><ExperimentOutlined /> Equipos patrón</span>, value: "patrones" },
                                ]}
                                value={vista}
                                onChange={this.cambiarVista}
                            />
                            <ButtonItem type="link" blanco onClick={() => this.setState({ openTour: true })}>
                                ¿Cómo funciona?
                            </ButtonItem>
                        </>
                    }
                />
                {vista === "emitidos" ? <CertificadosEmitidos {...this.props} /> : vista === "plantillas" ? <PlantillasCertificado {...this.props} /> : <EquiposPatron {...this.props} />}
                <TourItem
                    open={this.state.openTour}
                    onClose={() => this.setState({ openTour: false })}
                    steps={[
                        {
                            title: "1. Plantillas",
                            description:
                                "Cada plantilla es un formato de certificado (como las hojas del F-SE-14): qué se inspecciona antes y después del mantenimiento y qué se mide con su tolerancia. Cargue de un clic los 19 formatos F-SE-14 y ajústelos, o cree uno nuevo.",
                            target: null,
                        },
                        {
                            title: "2. Equipos patrón",
                            description: "Los simuladores y analizadores con su calibración. Al emitir un certificado se eligen y su calibración queda impresa. Se avisa cuando una calibración está por vencer.",
                            target: null,
                        },
                        {
                            title: "3. Emitir desde el servicio",
                            description:
                                "En la Orden de Servicio, paso Certificados, se elige la plantilla (se proponen las del tipo de equipo), se capturan los valores y el sistema calcula rangos y si cumple. Se descarga desde Descargar ▾, junto con la Orden y el reporte de visita.",
                            target: null,
                        },
                        {
                            title: "4. Vigencia",
                            description: "Cada certificado vale los meses de su plantilla (6 por default). Aquí se ven los vigentes, los por vencer (30 días) y los vencidos; el equipo muestra los vigentes en su ficha y en la página del QR.",
                            target: null,
                        },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Certificados);
